// Enable only on an evaluation build until real speech has passed listening tests.
export const acousticBoundariesEnabled=import.meta.env?.VITE_ACOUSTIC_BOUNDARIES==='true';
// Enable the safe, ranged-waveform assistant by default. Can be disabled
// instantly with VITE_WAVEFORM_ASSIST=false if an older browser needs it.
export const waveformAssistEnabled=import.meta.env?.VITE_WAVEFORM_ASSIST!=='false';
